<script setup>
import BreezeButton from '@/Components/Button.vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import FormField from "@/Components/FormField.vue";
import FormControl from "@/Components/FormControl.vue";

const props = defineProps({
    action: {
        type: String,
        default: 'view'
    },
    object: Object,
    roles: Object
});

const form = useForm({
    id: props.object?.id || null,
    name: props.object?.name || '',
    user: props.object?.user || '',
    email: props.object?.email || '',
    password: '',
    password_confirmation: '',
    terms: false,
    id_rol: props.object?.id_rol || '',
    rol_type: props.object?.rol_type || '',
});

const submit = () => {
    if (props.action === 'edit') {
        form.put(route('user-actualizar'), {
            onFinish: () => form.reset('password', 'password_confirmation'),
        });
    } else {
        form.post(route('user-registrar'), {
            onFinish: () => form.reset('password', 'password_confirmation'),
        });
    }
};

const rol_types = ['admin', 'maestro', 'estudiante', 'apoderado', 'coordinador', 'secretaria', 'diseño'];
</script>

<template>
    <BreezeAuthenticatedLayout>
        <Head title="Register" />
        
            <div><!--max-w-7xl-->
                <BreezeValidationErrors class="mb-4" />
        
                <div class="grid grids-col-1 bg-white rounded-lg shadow-lg p-6 ">
                    <template v-if="action=='edit'">
                        <form @submit.prevent="submit">
                            <div>
                                <BreezeLabel for="name" value="Name" />
                                <BreezeInput id="name" type="text" class="mt-1 block w-full" v-model="form.name" required autofocus autocomplete="name" />
                            </div>

                            <div class="mt-4">
                                <BreezeLabel for="user" value="User" />
                                <BreezeInput id="user" type="text" class="mt-1 block w-full" v-model="form.user" required autocomplete="user" />
                            </div>

                            <div class="mt-4">
                                <BreezeLabel for="email" value="Email" />
                                <BreezeInput id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autocomplete="username" />
                            </div>

                            <div class="mt-4">
                                <BreezeLabel for="password" value="Nueva Contraseña (opcional)" />
                                <BreezeInput id="password" type="password" class="mt-1 block w-full" v-model="form.password" autocomplete="new-password" />
                            </div>

                            <div class="mt-4">
                                <BreezeLabel for="password_confirmation" value="Confirmar Nueva Contraseña" />
                                <BreezeInput id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" autocomplete="new-password" />
                            </div>

                            <FormField label="Rol o grupo de usuarios / Interface de usuario" class="mt-4">
                                <FormControl v-model="form.id_rol" type="select" :options="roles" placeholder="Rol" />
                                <FormControl v-model="form.rol_type" type="select" :options="rol_types" placeholder="Interface" />
                            </FormField>

                            

                            <div class="flex items-center justify-end mt-4">
                                <!--<Link :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                    Already registered?
                                </Link>
                                -->
                                <Link :href="route('user-listado')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                    volver al listado
                                </Link>
                                <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                    Actualizar
                                </BreezeButton>
                            </div>
                        </form>
                    </template>
                    <template v-else>
                        <form @submit.prevent="submit">
                            <div>
                                <BreezeLabel for="name" value="Name" />
                                <BreezeInput id="name" type="text" class="mt-1 block w-full" v-model="form.name" required autofocus autocomplete="name" />
                            </div>

                            <div class="mt-4">
                                <BreezeLabel for="user" value="User" />
                                <BreezeInput id="user" type="text" class="mt-1 block w-full" v-model="form.user" required autocomplete="user" />
                            </div>

                            <div class="mt-4">
                                <BreezeLabel for="email" value="Email" />
                                <BreezeInput id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autocomplete="username" />
                            </div>

                            <div class="mt-4">
                                <BreezeLabel for="password" value="Password" />
                                <BreezeInput id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="new-password" />
                            </div>

                            <div class="mt-4">
                                <BreezeLabel for="password_confirmation" value="Confirm Password" />
                                <BreezeInput id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
                            </div>

                            <FormField label="Rol o grupo de usuarios / Interface de usuario">
                                <FormControl v-model="form.id_rol" type="select" :options="roles" placeholder="Rol" />
                                <FormControl v-model="form.rol_type" type="select" :options="rol_types" placeholder="Interface" />
                            </FormField>

                            <div class="flex items-center justify-end mt-4">
                                <!--<Link :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                    Already registered?
                                </Link>
                                -->
                                <Link :href="route('user-listado')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                    volver al listado
                                </Link>
                                <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                    Registrar
                                </BreezeButton>
                            </div>
                        </form>
                    </template>
                    
                </div>
            </div>
        
    </BreezeAuthenticatedLayout>
</template>
